import {
  Box, Grid, withStyles, Tooltip, Typography
} from '@material-ui/core';
import React, { useState } from 'react';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import styled from 'styled-components';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import { useLanguage } from '../../../../context/language/language';
import { useTheme } from '../../../../context/theme/theme';

const WarningDescription = styled.div(({ theme, color }) => ({
  ...theme.fonts.textS,
  fontWeight: 400,
  color: color || theme.colors.grey700,
}));

const BoxTooltip = styled(Box)(({ theme }) => ({
  backgroundColor: 'white',
  width: 232,
  whiteSpace: 'pre-line'
}));

const TooltipCustom = withStyles((theme) => ({
  tooltip: {
    backgroundColor: theme.palette.common.white,
    color: theme.custom.colors.grey550,
    maxWidth: 'none',
    marginTop: 8,
    filter: 'drop-shadow(0 0 4px rgba(0, 0, 0, 0.08)) drop-shadow(0 -4px 32px rgba(0, 0, 0, 0.1))',
    ...theme.custom.fonts.textS,
    ...theme.custom.radius.m,

    [theme.breakpoints.up('sm')]: {
      filter: 'drop-shadow(0 0 4px rgba(0, 0, 0, 0.08)) drop-shadow(0 6px 24px rgba(0, 0, 0, 0.1))',
    }
  },
  popper: {
    zIndex: 1500
  },
  arrow: {
    color: '#fff',
    '&:before': {
      border: '1px solid #e6e8ed'
    },
  },
}))(Tooltip);

const TooltipText = styled(Typography)(({ theme }) => ({
  fontSize: 14,
  color: theme.colors.grey550,
}));
const TooltipTitleText = styled(Typography)(({ theme }) => ({
  fontSize: 14,
  fontWeight: 700,
  color: theme.colors.grey700,
}));
export const StoreCloseWarning = ({ time = '' }) => {
  const word = useLanguage();
  const theme = useTheme();

  const message = word('Store.OpenHour.Closed').replace('%s', time);
  return (
    <Grid item>
      <Box display="flex" alignItems="center">
        <AccessTimeIcon style={{ width: 18, paddingRight: 5, color: theme.colors.yellow600 }} />
        <WarningDescription>
          {/* {word('OrderSummary.StoreClose')} */}
          {message}
        </WarningDescription>
      </Box>
    </Grid>
  );
};

export const StoreCloseWarningMobile = ({ time = '' }) => {
  const word = useLanguage();
  const theme = useTheme();
  const [tooltipCidIsOpen, setTooltipCidIsOpen] = useState(false);
  const message = word('Store.OpenHour.Closed').replace('%s', time);
  return (
    <TooltipCustom
      open={tooltipCidIsOpen}
      arrow
      title={(
        <BoxTooltip>
          {/* <TooltipTitleText>
            {word('OrderSummary.StoreClose')}
          </TooltipTitleText> */}
          <TooltipText>
            {message}
          </TooltipText>
        </BoxTooltip>
                  )}
      placement="bottom"
    >
      <Box
        onMouseOut={(e) => setTooltipCidIsOpen(false)}
        onClick={(e) => setTooltipCidIsOpen(!tooltipCidIsOpen)}
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignContent: 'center'
        }}
      >
        <InfoOutlinedIcon style={{ width: 18, paddingLeft: 5, color: theme.colors.black }} />
      </Box>

    </TooltipCustom>
  );
};

export default {};
